import { render, staticRenderFns } from "./ListLabelPage.vue?vue&type=template&id=74f4eb8c"
import script from "./ListLabelPage.vue?vue&type=script&lang=js"
export * from "./ListLabelPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports